import Plusone from '@/components/api/plusone';

/** updateStampCount のスタンプアニメーション用。再実行時に前回の setTimeout を破棄して点滅を防ぐ */
let stampAnimationTimeouts = [];

function clearStampAnimation() {
  stampAnimationTimeouts.forEach((id) => clearTimeout(id));
  stampAnimationTimeouts = [];
}

const state = {
  bcNo: '001',
  stampCount: 0,
  /** get_stamp の stampCount（アニメーションなし・即時）。達成判定UI用 */
  stampCountFromApi: 0,
  giftProductMap: [],
  stampStatus: null,
  selectedGiftProduct: null,
  giftSelectionDeadline: '',
}

const getters = {
  bcNo: state => state.bcNo,
  stampCount: state => state.stampCount,
  stampCountFromApi: state => state.stampCountFromApi,
  giftProductMap: state => state.giftProductMap,
  stampStatus: state => state.stampStatus,
  selectedGiftProduct: state => state.selectedGiftProduct,
  giftSelectionDeadline: state => state.giftSelectionDeadline,
}

const actions = {
  updateStampCount({ state, commit }) {
    const maxStampCount = 13;
    Plusone.getStamp(state.bcNo).then((val) => {
      console.log('getStamp', val);
      console.log('val.giftProductMap', val.giftProductMap);
      if(val) {
        // 選択済みプレゼント製品がある場合は常にセット（お届け後もリセットしない仕様）
        if(val.giftProductMap && val.giftProductMap[0] && val.giftProductMap[0].giftProductId !== 0) {
          commit('setSelectedGiftProduct', val.giftProductMap[0]);
        } else {
          commit('setSelectedGiftProduct', null);
        }
        commit('setStampStatus', val.status);
        commit('setGiftSelectionDeadline', val.giftSelectionDeadline != null ? val.giftSelectionDeadline : '');
        commit('setStampCountFromApi', val.stampCount != null ? val.stampCount : 0);
        let stampCount = val.stampCount;
        if(stampCount === 12) {
          stampCount = 13;
        }
        clearStampAnimation();
        // 既に同じ枚数まで表示済みならアニメーションを再実行しない（画面遷移で get_stamp が再度走る点滅対策）
        if (state.stampCount === stampCount) {
          return;
        }
        for (let i = 0; i <= stampCount; i++) {
          if (i > maxStampCount) {
            break;
          }
          const id = setTimeout(() => {
            commit('setStampCount', i);
          }, i * 500); // 0.5秒ごとに更新
          stampAnimationTimeouts.push(id);
        }
      }
    }).catch((error) => {
      console.error('Failed to get stamp:', error);
    });
  },
  fetchAllProduct({ commit }, bcNo) {
    Plusone.getAllPresents(bcNo).then((val) => {
      console.log('getAllProduct', val);
      if(val) {
        commit('setGiftProductMap', val.giftProductMap);
      }
    });
  }
}

const mutations = {
  setMemberId(state, memberId) {
    state.memberId = memberId;
  },
  setStampCount(state, count) {
    state.stampCount = count;
  },
  setStampCountFromApi(state, count) {
    state.stampCountFromApi = count;
  },
  setGiftProductMap(state, map) {
    state.giftProductMap = map;
  },
  setStampStatus(state, status) {
    state.stampStatus = status;
  },
  setSelectedGiftProduct(state, product) {
    state.selectedGiftProduct = product;
  },
  setGiftSelectionDeadline(state, value) {
    state.giftSelectionDeadline = value || '';
  },
}


export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/keepgoing.js